import React from 'react';
import { Routes, Route, Navigate, useSearchParams } from 'react-router-dom';

import ProtectedRoute from './components/ProtectedRoute';

import './App.css';
import EmailSenderPage from './pages/EmailSenderPage';
import CertificateViewPage from './pages/CertificateViewPage';
import CertificatesPage from './pages/CertificatesPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import AdminPanelPage from './pages/AdminPanelPage';
import CoursesPage from './pages/CoursesPage';
import HomePage from './pages/HomePage';
import AskExpertPage from './pages/AskExpertPage';
import SubmittedQuestionsPage from './pages/SubmittedQuestionsPage';
import RoadmapFullstackJavaScriptPage from './pages/RoadmapFullstackJavaScriptPage';
import RoadmapFullstackJavaPage from './pages/RoadmapFullstackJavaPage';
import RoadmapAwsDevOpsPage from './pages/RoadmapAwsDevOpsPage';
import DSALabPage from './pages/DSALabPage';
import ProblemsPage from './pages/ProblemsPage';
import ProblemDetailPage from './pages/ProblemDetailPage';
import LearnPage from './pages/LearnPage';
import InterviewAssistantPage from './pages/InterviewAssistantPage';

import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';

// Backward-compatible: if cert query params exist at /, render cert view
const HomeOrCertRoute = () => {
  const [searchParams] = useSearchParams();
  const certToken = searchParams.get('cert');
  const certId = searchParams.get('certId');
  if (certToken || certId) return <CertificateViewPage />;
  return <HomePage />;
};

const App = () => (
  <Routes>
    <Route path="/" element={<HomeOrCertRoute />} />
    <Route path="/login" element={<LoginPage />} />
    <Route path="/signup" element={<SignupPage />} />

    {/* Certificate view is public - accessed via /cert-view?cert=... or /cert-view?certId=... */}
    <Route path="/cert-view" element={<CertificateViewPage />} />

    {/* Protected routes - require login */}
    <Route
      path="/certificates"
      element={(
        <ProtectedRoute>
          <CertificatesPage />
        </ProtectedRoute>
      )}
    />
    <Route
      path="/emailsender"
      element={(
        <ProtectedRoute>
          <EmailSenderPage />
        </ProtectedRoute>
      )}
    />

    {/* Admin-only route */}
    <Route
      path="/admin"
      element={(
        <ProtectedRoute adminOnly>
          <AdminPanelPage />
        </ProtectedRoute>
      )}
    />
    <Route
      path="/submitted-questions"
      element={(
        <ProtectedRoute adminOnly>
          <SubmittedQuestionsPage />
        </ProtectedRoute>
      )}
    />

    {/* Public courses page */}
    <Route path="/courses" element={<CoursesPage />} />
    <Route path="/courses-roadmaps" element={<CoursesPage focusRoadmaps />} />
    <Route path="/ask-expert" element={<AskExpertPage />} />
    <Route path="/roadmap-to-fullstack-javascript-course" element={<RoadmapFullstackJavaScriptPage />} />
    <Route path="/roadmap-to-fullstack-java-course" element={<RoadmapFullstackJavaPage />} />
    <Route path="/roadmap-to-aws-devops-course" element={<RoadmapAwsDevOpsPage />} />
    <Route path="/dsa-lab" element={<Navigate to="/problems" replace />} />
    <Route path="/problems" element={<ProblemsPage />} />
    <Route path="/problem/:slug" element={<ProblemDetailPage />} />
    <Route path="/learn" element={<LearnPage />} />
    <Route path="/learn/topic/:topicId" element={<LearnPage />} />
    <Route path="/interview-assistant" element={<InterviewAssistantPage />} />
    <Route path="/legacy-dsa-lab" element={<DSALabPage />} />
  </Routes>
);

export default App;
